// import React from "react";
// import * as S from "./TranducerMessagesList.style";
// import { useTranslation } from "react-i18next";
// import { v4 as uuidv4 } from 'uuid';

// function TranducerMessagesList({
//   transducerState,
//   transducerType,
//   transcription,
//   messages
// }) {

//   const { t } = useTranslation("global");

//   if(transducerType === 2)
//     return (
//       <S.TranducerMessagesList>
//         {
//           messages.map((message) => {
//             return (
//               <S.Message
//                 patient={!message.messagerType}
//                 transducerState={transducerState}
//                 key={uuidv4()}
//               >
//                 <div className="label">{message.messageType ? t("globally.patient") : t("globally.you")}</div>
//                 <div className="box">{message.messageText}</div>
//               </S.Message>
//             )
//           })
//         }
//       </S.TranducerMessagesList>
//     );

//   if(transducerType === 1)
//     return (
//       <S.TranducerMessagesList>
//         <S.Message
//           patient={false}
//           transducerState={transducerState}
//           transducerType={transducerType}
//         >
//           <div className="label">{t("globally.note")}</div>
//           {
//             transcription
//             ? <div className="box">{transcription}</div>
//             : ""
//           }
//         </S.Message>
//       </S.TranducerMessagesList>
//     );
          
// }

// export default TranducerMessagesList;



import React from "react";
import * as S from "./TranducerMessagesList.style";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

function TranducerMessagesList({
  transducerState,
  transducerType,
  transcription,
  messages
}) {
  const { t } = useTranslation("global");

  // [NUEVO] Detección de modo Batch/Diarización:
  // Si el primer mensaje tiene la propiedad 'persona', es porque viene del backend de Python.
  const isDiarization = messages && messages.length > 0 && messages[0].persona;

  if (isDiarization) {
    return (
      <S.TranducerMessagesList>
        {messages.map((message) => (
          <S.Message
            key={uuidv4()}
            speaker={message.persona} // Para determinar el color (Persona 1, 2, etc)
            patient={true}       // Forzamos alineación a la izquierda para lectura batch
          >
            <div className="label">{message.persona}</div>
            <div className="box">{message.mensaje}</div>
          </S.Message>
        ))}
      </S.TranducerMessagesList>
    );
  }

  // --- LÓGICA ORIGINAL (No se toca para no dañar lo existente) ---

  if (transducerType === 2)
    return (
      <S.TranducerMessagesList>
        {messages.map((message) => {
          return (
            <S.Message
              patient={!message.messagerType}
              transducerState={transducerState}
              key={uuidv4()}
            >
              <div className="label">
                {message.messageType ? t("globally.patient") : t("globally.you")}
              </div>
              <div className="box">{message.messageText}</div>
            </S.Message>
          );
        })}
      </S.TranducerMessagesList>
    );

  if (transducerType === 1)
    return (
      <S.TranducerMessagesList>
        <S.Message
          patient={false}
          transducerState={transducerState}
          transducerType={transducerType}
        >
          <div className="label">{t("globally.note")}</div>
          {transcription ? (
            <div className="box">{transcription}</div>
          ) : (
            transducerState === "connecting" && (
              <div className="box" style={{ fontStyle: "italic", opacity: 0.5 }}>
                {t("transductor.generatingTransduction")}...
              </div>
            )
          )}
        </S.Message>
      </S.TranducerMessagesList>
    );

  return null;
}

export default TranducerMessagesList;